import { Injectable } from '@angular/core';
import { ContactCardDto } from '@hub/generated/models';
import { ConfirmationService } from 'primeng/api';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ShareConfirmationService {

  constructor(
    private confirmationService: ConfirmationService
  ) { }

  private _confirmResult = new Subject<boolean>();
  isConfirmationShow: boolean;

  confirm$(): Observable<boolean> {
    this.confirmUnsavedChanges();
    return this._confirmResult.asObservable().pipe(take(1));
  }
  
  confirmUnsavedChanges() {
    if (!this.isConfirmationShow) {
      this.isConfirmationShow = true;
      this.confirmationService.confirm({
          key: 'common',
          message: 'You have unsaved changes. Are you sure you want to leave this page?',
          accept: () => {
            this._confirmResult.next(true);
            this.isConfirmationShow = false;
          },
          reject: () => {
            this._confirmResult.next(false);
            this.isConfirmationShow = false;
          }
        });
    }
  }
}
